import { useTranslation } from 'react-i18next';
import SuccessScreen from '@/components/ui/SuccessScreen/SuccessScreen';

interface SupportRequestSuccessScreenProps {
  onBackToSupportRequests: () => void;
  onAddAnotherRequest: () => void;
}

const SupportRequestSuccessScreen = ({ onBackToSupportRequests, onAddAnotherRequest }: SupportRequestSuccessScreenProps) => {
  const { t } = useTranslation();

  return (
    <SuccessScreen
      title={t('supportRequestAddedSuccessfully')}
      primaryButtonText={t('backToSupportRequests')}
      primaryButtonAction={onBackToSupportRequests}
      secondaryButtonText={t('addAnotherRequest')}
      secondaryButtonAction={onAddAnotherRequest}
    />
  );
};

export default SupportRequestSuccessScreen;
